import styles from "./StatisticsEventDialog.module.scss";
import { IStatisticDetailedItemViewModel } from "../models/statisticDetailedItemViewModel";
import { dateUtility } from "../../../common/infrastructure/utilities/dateUtility";
import { StatisticsDialogKeyValueItem } from "./StatisticsDialogKeyValueItem";
import { Tag } from "../../../common/components/common/Tag/Tag";
import { EventTypeShortLabels } from "../../../common/labels";
import { EventType } from "../../../common/enums";
import { getGroupTypeIndicatorClass } from "../../planner/planner/components/utils/EventItemUtility";
import { classNames } from "primereact/utils";
import {
  IfFalse,
  IfTrue,
  RenderWhen,
} from "../../../common/infrastructure/components/RenderWhen";
import { useNavigate } from "react-router-dom";
import { constructPlannerEventHref } from "../../../common/infrastructure/routes/routePaths";
import { PriceDisplay } from "../../../common/components/PriceDisplay/PriceDisplay";

interface IStatisticsPlanDialogProps {
  item: IStatisticDetailedItemViewModel;
}

export const StatisticsEventDialog = ({ item }: IStatisticsPlanDialogProps) => {
  const eventTypeCLass = getGroupTypeIndicatorClass(item.eventType);
  const navigate = useNavigate();

  const onClick = () => {
    if (!item.id) {
      return;
    }

    const link = constructPlannerEventHref(item.id);
    navigate(link);
  };

  return (
    <div className={styles.root} onClick={onClick}>
      <div className={styles.root_header}>
        <div className={styles.root_header_left}>
          <h5>
            {item.name} <span>(#{item.id})</span>
          </h5>
          <p>
            Дата на класа:{" "}
            <span>{dateUtility.formatDateTime(item.dateTime)}</span>
          </p>
        </div>
        <div className={styles.root_headear_right}>
          <div>
            <Tag
              className={classNames(
                styles.root_header_right_tag,
                eventTypeCLass
              )}
              fontColor={"#fff"}
              label={EventTypeShortLabels[item.eventType ?? EventType.Group]}
            />
          </div>
        </div>
      </div>

      <div className={styles.root_content}>
        <StatisticsDialogKeyValueItem
          name={"ОБЩ ОБОРОТ"}
          value={
            !!item.pricePaidInEur ? (
              <PriceDisplay minPrice={item.pricePaidInEur} />
            ) : (
              "€ 0.00"
            )
          }
        />
        <RenderWhen condition={item.eventType === EventType.Group}>
          <IfTrue>
            <StatisticsDialogKeyValueItem
              name={"БРОЙ ПОТРЕБИТЕЛИ"}
              value={`${item.eventTakenSpaces}/${item.eventTotalSpaces}`}
            />
          </IfTrue>
          <IfFalse>
            <StatisticsDialogKeyValueItem
              name={"ПОТРЕБИТЕЛ"}
              value={item.userName}
            />
          </IfFalse>
        </RenderWhen>
      </div>
    </div>
  );
};
